import { notificationConstants } from '../constants'

export function notification(state = {}, action) {
  switch (action.type) {
    case notificationConstants.SUCCESS:
      return {
        ...state,
        messageType: 'success',
        message: action.message
      };
    case notificationConstants.ERROR:
      return {
        ...state,
        messageType: 'error',
        message: action.message
      };
    case notificationConstants.CLEAR:
      return {...state, message: null};
    default:
      return state
  }
}